export default "__VITE_ASSET__b1c828d3__"